// TODO: Properly implement this at one point using it's plugin.

import LogRocket from "logrocket";

let isInitialized = false;
const initialize = (callback?: () => void) => {
  console.log("LogRocket initializing...");
  if (typeof window === "undefined") {
    console.log("LogRocket initialization skipped. Running in server environment.");
    return;
  }

  const logRocketKey = import.meta.env.CLIENT_LOGROCKET_PROJECT_ID;

  if (!logRocketKey || logRocketKey === "undefined" || logRocketKey === "preview") {
    console.info("LogRocket initialization skipped. Invalid or missing project ID:", logRocketKey);
    return;
  }

  if (isInitialized) {
    console.warn("LogRocket already initialized with project ID:", logRocketKey);
    return;
  }

  console.log("LogRocket initialized with project ID:", logRocketKey);
  LogRocket.init(logRocketKey);
  isInitialized = true;

  callback?.();
};

const identify = (userId: string, email: string, fullName: string) => {
  if (!import.meta.env.PROD) {
    console.log("LogRocket identify, -- skipped", userId, email, fullName);
    return;
  }

  if (!isInitialized) {
    console.log("LogRocket identify, -- initializing...");
    initialize(() => identify(userId, email, fullName));
    return;
  }

  LogRocket.identify(userId, {
    name: fullName,
    email,
  });
};

export default {
  identify,
};
